import React, { useState } from 'react'
import { Button, styled, Box, TextField } from '@mui/material'
import { helpGetUserLoginAccountWithEmail } from '../../../../app/services/LoginAccount/helpGetUserLoginAccountWhitEmail'
import { useNavigate } from 'react-router-dom'

import { useDispatch } from 'react-redux'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar
} from '../../../../redux/actions/app'

const InputContainer = styled(Box)(() => ({
  width: '30rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignContent: 'center',
  gap: '1.5rem',
  // top
  padding: '5% 0% 0% 7%',
  '@media all and (max-width: 700px)': {
    width: '80%'
  }
}))

const BoxInput = styled(Box)(() => ({
  width: '30rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignContent: 'center',
  gap: '1.5rem',
  color: '#4B4952',
  fontSize: 18,
  fontFamily: 'roboto',
  '@media all and (max-width: 700px)': {
    width: '100%'
  }
}))

const BoxRoot = styled(Box)(() => ({
  width: '100%',
  overflow: 'hidden'
}))

const InputButton = styled(Button)(() => ({
  background: '#1C846F',
  '&:hover': {
    background: '#0CABA8'
  },
  borderRadius: '5rem',
  color: '#fff'
}))

export const SearchUser = ({ setLoading }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')

  const [error, seterror] = React.useState(false)

  const handleChangeEmail = (event) => {
    seterror(false)
    setEmail(event.target.value)
  }
  const searchUser = () => {
    if (!error) {
      handleGetUser()
    }
  }

  const handleGetUser = async (param = email) => {
    setLoading(true)
    try {
      const response = await helpGetUserLoginAccountWithEmail(param)

      const userId = response.data?.loginAccount?.loginAccountId

      if (userId) {
        navigate(`/security/user-sessions/${userId}`)
      } else {
        seterror(true)
      }
    } catch (err) {
      if (err.response?.data?.error?.message !== 'Verify LoginAccount email.') {
        dispatch(setRequestTextSnackBar())
        dispatch(setErrorTextSnackBar('Ocurrió un error. Intente nuevamente'))
        // error
      }
      seterror(true)
    }
    setLoading(false)
  }

  const handleSearchSubmit = (event) => {
    if (event.type === 'keydown' && event.key === 'Enter' && email !== '') {
      searchUser()
    }
  }

  return (
    <BoxRoot>
      <InputContainer>
        <BoxInput>
          <div style={{ fontWeight: 'lighter' }}>
            Ingrese el email del usuario que desea buscar:
          </div>
        </BoxInput>
        <TextField
          value={email}
          onChange={handleChangeEmail}
          onKeyDown={handleSearchSubmit}
          placeholder={'Ej: persona@mail.com'}
          error={error}
          helperText={error ? 'No se encontró el usuario ingresado.' : ''}
        />

        <InputButton onClick={searchUser}>Buscar</InputButton>
      </InputContainer>
    </BoxRoot>
  )
}
